import React from 'react'
import { BsLinkedin } from 'react-icons/bs'
import { FaGithub, FaCode } from 'react-icons/fa'
import { IconContext } from "react-icons";

const HeaderSocials = ({ links }) => {
  return (
    <div className="header__socials">

      <IconContext.Provider value={{ className: "shared-class", size: 30 }}>
        <a href={links.linkedin} target="_blank" rel="noreferrer" title='linkedin profile'><BsLinkedin /></a>
        <a href={links.github} target="_blank" rel="noreferrer" title='github profile'><FaGithub /></a>
        <a href={links.leetcode} target="_blank" rel="noreferrer" title='leetcode profile'><FaCode /></a>
      </IconContext.Provider>
    </div>
  )
}

export default HeaderSocials